import { registerBuiltInExtensions } from './registry/build-in';
registerBuiltInExtensions();
//# sourceMappingURL=preset.js.map